import * as React from "react";
import { useTransactionUploadV2 } from "@iliotech/data-wire/src/stores";
import {
  InputChangeEvent,
  NumericTextBox,
  NumericTextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { TransactionTableCellProps } from "./DateCell";
import { observer } from "mobx-react-lite";
const QuantityCell = ({ index }: TransactionTableCellProps) => {
  const store = useTransactionUploadV2();
  const quantity = store.equities.getField("quantity", index + "") as number;

  const onChange = (event: NumericTextBoxChangeEvent) => {
    store.equities.updateTableRowByIndex("quantity", event.value, index + "");
  };

  return (
    <NumericTextBox
      name={"quantity"}
      value={quantity}
      format={{
        maximumFractionDigits: 5,
      }}
      spinners={false}
      onChange={onChange}
    />
  );
};

export default observer(QuantityCell);
